import Header from "components/Header";
import ModalConfirmLogout from "components/ModalConfirmLogout";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "./CasinoSwiper.css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import BackgroundVideo from "components/BackgroundVideo";

const imageCasino = [
  {
    url: "/assets/casino-ae.png",
    link: "/lobby",
    name: "ae-sexy",
  },
  {
    url: "/assets/casino-dream.png",
    link: "/lobby",
    name: "dream",
  },
  {
    url: "/assets/casino-wm.png",
    link: "/lobby",
    name: "wm",
  },
  {
    url: "/assets/casino-venus.png",
    link: "/lobby",
    name: "venus",
  },
  {
    url: "/assets/casino-vivo.png",
    link: "/lobby",
    name: "vivo",
  },
  {
    url: "/assets/casino-ag.png",
    link: "/lobby",
    name: "vivo",
  },
  {
    url: "/assets/casino-bg.png",
    link: "/lobby",
    name: "vivo",
  },
  {
    url: "/assets/casino-venus.png",
    link: "/lobby",
    name: "venus",
  },
  {
    url: "/assets/casino-vivo.png",
    link: "/lobby",
    name: "vivo",
  },
];

export default function HomeCasino() {
  const navigate = useNavigate();

  const [showMaintenance, setShowMaintenance] = useState(false);
  const handleClick = (casino: any) => {
    if (casino.name === "ae-sexy") {
      navigate(`/casino${casino.link}`);
    } else {
      setShowMaintenance(true);
    }
  };
  const [isShowLogout, setIsShowLogout] = useState(false);
  return (
    <section
      className="min-h-screen md:px-14 px-4 bg-fixed bg-cover"
      // style={{
      //   backgroundImage: `url('/assets/bg-new.png')`,
      // }}
    >
      <BackgroundVideo />
      <Header setIsShowLogout={() => setIsShowLogout(true)} />
      <div className="md:py-20 py-12" />
      {/* btn back */}
      <div
        className="flex justify-end items-center cursor-pointer md:mb-2 mb-6 md:mt-0 mt-2 btn-hover"
        onClick={() => navigate("/")}
      >
        <img
          className="md:w-[239px] md:h-[69px] w-1/3 "
          src="/assets/btn-back.png"
          alt="Quay lại"
        />
      </div>
      {/* list card */}
      <div className="flex flex-col justify-center items-center">
        <img
          src="/assets/casino-title.png"
          alt="CASINO ROOM"
          className="md:mb-20"
        />
        {/* pc */}
        <div className="w-[80%] md:block hidden">
          <Swiper
            modules={[Navigation, Pagination]}
            spaceBetween={20}
            slidesPerView={5}
            centeredSlides={true} // Đưa slide active vào giữa
            loop={true} // Lặp lại để không bị trống 2 đầu khi dùng centered
            // loopAdditionalSlides={7}
            navigation={true}
            breakpoints={{
              // 640: { slidesPerView: 2 },
              768: { slidesPerView: 4 },
              1024: { slidesPerView: 5 },
            }}
            pagination={{
              clickable: true,
            }}
            className="casino-swiper "
          >
            {imageCasino.map((item) => (
              <SwiperSlide key={item.name}>
                {/* SwiperSlide sẽ tự có class swiper-slide-active khi nó nằm giữa */}
                <div className="item-container transition-all duration-500 ease-in-out">
                  <button
                    onClick={() => handleClick(item)}
                    className="btn-hover w-full outline-none block"
                  >
                    <img
                      src={item.url}
                      alt={item.name}
                      className="w-full h-auto object-cover rounded-lg shadow-lg"
                    />
                  </button>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* mobile */}
        <div className="md:hidden block mt-6">
          <div className="flex gap-2 mb-4">
            {imageCasino.slice(0, 2).map((item) => {
              return (
                <button
                  key={item.name}
                  onClick={() => {
                    handleClick(item);
                  }}
                  className="btn-hover"
                >
                  <img src={item.url} alt={item.name} />
                </button>
              );
            })}
          </div>
          <div className="flex gap-2 mb-4">
            {imageCasino.slice(2, 4).map((item) => {
              return (
                <button
                  key={item.name}
                  onClick={() => {
                    handleClick(item);
                  }}
                  className="btn-hover"
                >
                  <img src={item.url} alt={item.name} />
                </button>
              );
            })}
          </div>
          {/* <div className="relative flex justify-center items-center"> */}
          <div className="flex gap-2">
            {imageCasino.slice(4, 6).map((item) => {
              return (
                <button
                  key={item.name}
                  onClick={() => {
                    handleClick(item);
                  }}
                  className="btn-hover"
                >
                  <img src={item.url} alt={item.name} />
                </button>
              );
            })}
          </div>
          <div className="flex gap-2">
            {imageCasino.slice(5, 7).map((item) => {
              return (
                <button
                  key={item.name}
                  onClick={() => {
                    handleClick(item);
                  }}
                  className="btn-hover"
                >
                  <img src={item.url} alt={item.name} />
                </button>
              );
            })}
          </div>
          {/* btn tele-fb */}
          {/* <div className="md:hidden absolute right-0 inline-block">
              <div className="grid grid-cols-1 gap-4 justify-items-end">
                <a href="">
                  <img
                    className="w-10 cursor-pointer"
                    src="/assets/facebook.png"
                  />
                </a>
                <a href="">
                  <img className="w-10 cursor-pointer" src="/assets/tele.png" />
                </a>
              </div>
            </div> */}
          {/* </div> */}
        </div>
      </div>

      {/* Maintenance Modal */}
      {showMaintenance && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg p-4 sm:p-6 md:p-8 max-w-sm sm:max-w-md mx-4 text-center">
            <div className="text-4xl sm:text-6xl mb-3 sm:mb-4">🔧</div>
            <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4 text-gray-800">
              Đang Bảo Trì
            </h3>
            <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">
              Hệ thống đang được bảo trì. Vui lòng thử lại sau!
            </p>
            <button
              onClick={() => setShowMaintenance(false)}
              className="bg-blue-500 hover:bg-blue-600 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg transition-colors text-sm sm:text-base"
            >
              Đóng
            </button>
          </div>
        </div>
      )}

      {/* Modal Logout */}
      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => {
          setIsShowLogout(false);
        }}
      />
    </section>
  );
}
